import { type Conversation } from '@twilio/conversations'

export type ConversationType = Conversation & {
  otherUser?: { name: string; image?: string }
}
export type ClientInfoType = {
  readonly firstName?: string
  readonly lastName?: string
  readonly email: string
}

export const COUNSELLING_CONVERSATION_PREFIX = 'counselling-'
